<template>
  <div class="blog-wrapper">

    <!-- content -->
    <div class="blog-detail-wrapper" v-if="movieDetail">
      <b-row>
        <!-- blogs -->
        <b-col cols="12">
          <b-card
              _img-top
              _img-alt="Постер"
              _:title="`${movieDetail.title_ru} / ${movieDetail.title_en} (${movieDetail.year})`"
              class="movie-detail-card"
              :style="movieDetail.cover ? { '--movie-cover': `url(${movieDetail.cover})` } : {}"
          >
            <h1 class="d-flex flex-wrap align-items-center">
              <div class="movie-header-panel movie-title-panel">
                <span class="movie-title-ru">{{ movieDetail.title_ru }}</span>
                <span v-if="movieDetail.title_en" class="movie-title-original"> / {{ movieDetail.title_en }}</span>
                <span class="movie-title-original"> ({{ movieDetail.year }})</span>
              </div>
              <div class="d-flex ml-auto align-items-center movie-header-panel">
                <span class="font-weight-bold font-large-2 ml-1">
                  <span
                      :class="(movieDetail.rating_kp < 5) ? 'text-danger' : (movieDetail.rating_kp < 7) ? 'text-gray' : 'text-success'"
                  >
                    {{ ratingFmt(movieDetail.rating_kp) }}
                  </span>
                  <div class="small">{{ formatNumber(movieDetail.votes_kp) }}</div>
                </span>
                <span class="font-weight-bold font-large-1 ml-1">
                  <span
                      :class="(movieDetail.rating_imdb < 5) ? 'text-danger' : (movieDetail.rating_imdb < 7) ? 'text-gray' : 'text-success'"
                  >
                    {{ ratingFmt(movieDetail.rating_imdb) }}
                  </span>
                  <div class="small">{{ formatNumber(movieDetail.votes_imdb) }}</div>
                </span>
                <div class="d-flex flex-column ml-2">
                  <b-button
                      variant="outline-primary"
                      size="sm"
                      class="mb-50 text-nowrap"
                      @click="openRatingHistory('rating')"
                  >
                    <feather-icon
                        icon="TrendingUpIcon"
                        class="mr-50"
                    />
                    <span class="align-middle">Рейтинг</span>
                  </b-button>
                  <b-button
                      variant="outline-primary"
                      size="sm"
                      class="text-nowrap"
                      @click="openRatingHistory('votes')"
                  >
                    <feather-icon
                        icon="BarChart2Icon"
                        class="mr-50"
                    />
                    <span class="align-middle">Оценки</span>
                  </b-button>
                </div>
              </div>
            </h1>

            <b-row>
              <b-col
                  cols="12"
                  md="3"
                  class="d-flex flex-column align-items-center mb-2 mb-md-0"
              >
                <div class="poster-view-wrapper w-100">
                  <b-img
                      :src="currentPosterView"
                      alt="Постер"
                      class="product-img poster-view-img"
                      fluid
                  />
                  <b-button
                      v-if="movieDetail.posters_count"
                      variant="flat-secondary"
                      class="btn-icon rounded-circle poster-nav-btn poster-nav-btn-left"
                      :disabled="posterViewIndex === 0"
                      @click="goPrevPosterView"
                  >
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </b-button>
                  <b-button
                      v-if="movieDetail.posters_count"
                      variant="flat-secondary"
                      class="btn-icon rounded-circle poster-nav-btn poster-nav-btn-right"
                      :disabled="posterViewIndex >= posterViewList.length - 1"
                      @click="goNextPosterView"
                  >
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </b-button>
                  <b-button
                      v-if="currentPosterView"
                      variant="flat-secondary"
                      class="btn-icon rounded-circle poster-nav-btn poster-zoom-btn"
                      @click="isPosterZoomVisible = true"
                  >
                    <feather-icon icon="ZoomInIcon" size="18" />
                  </b-button>
                </div>
                <div v-if="movieDetail.posters_count" class="text-center text-muted small mt-50">
                  {{ posterViewIndex + 1 }} / {{ posterViewList.length }}
                </div>
                <div class="mt-1">
                  <b-form-checkbox
                      v-model="movieDetail.poster_has_director_name"
                      switch
                      @change="updatePosterFlag('poster_has_director_name', $event)"
                  >
                    Имя режиссёра на постере
                  </b-form-checkbox>
                  <b-form-checkbox
                      v-model="movieDetail.poster_has_actor_names"
                      switch
                      class="mt-50"
                      @change="updatePosterFlag('poster_has_actor_names', $event)"
                  >
                    Имена актёров на постере
                  </b-form-checkbox>
                </div>
                <b-button
                    variant="outline-primary"
                    size="sm"
                    block
                    class="mt-1"
                    @click="isPostersModalVisible = true"
                >
                  <feather-icon icon="ImageIcon" class="mr-50 align-middle" />
                  <span class="align-middle">Постеры</span>
                  <b-badge
                      v-if="movieDetail.posters_count"
                      pill
                      class="ml-50 align-middle posters-count-badge"
                  >
                    {{ movieDetail.posters_count }}
                  </b-badge>
                </b-button>

                <!-- Франшизы. Стили блока в Vuexy вложены в .blog-sidebar, поэтому класс сохранён -->
                <div class="blog-sidebar w-100 mt-2">
                  <div class="blog-recent-posts">
                    <div class="d-flex justify-content-between align-items-center mb-75">
                      <h6 class="section-label mb-0">
                        Франшизы
                      </h6>
                      <b-button
                          variant="outline-primary"
                          size="sm"
                          @click="openFranchiseModal"
                      >
                        <feather-icon icon="PlusIcon" class="mr-25"/>
                        <span>Привязать</span>
                      </b-button>
                    </div>

                    <div
                        v-for="franchise in franchises"
                        :key="franchise.id"
                        class="mb-2"
                    >
                      <h6 class="blog-recent-post-title mb-75">
                        <b-link
                            :to="{name: 'franchise-view', params: {id: franchise.id}}"
                            class="text-body-heading"
                        >
                          <feather-icon icon="LayersIcon" class="mr-25"/>
                          {{ franchise.title }}
                        </b-link>
                      </h6>
                      <b-media
                          v-for="(item, index) in franchiseWindow(franchise)"
                          :key="item.id"
                          no-body
                          :class="index ? 'mt-1' : ''"
                      >
                        <b-media-aside class="mr-1">
                          <b-img
                              :src="item.poster_preview"
                              width="42"
                              rounded
                          />
                        </b-media-aside>
                        <b-media-body>
                          <h6 class="blog-recent-post-title mb-0">
                            <b-link
                                :to="{name: 'movie-view', params: {id: item.id}}"
                                class="text-body-heading"
                                :class="{'font-weight-bolder': item.id === currentMovieId}"
                            >
                              {{ item.title_ru }}
                            </b-link>
                            <b-badge
                                v-if="item.part_number"
                                variant="light-primary"
                                class="ml-25"
                            >
                              {{ item.part_number }}
                            </b-badge>
                          </h6>
                          <span class="text-muted">{{ formatDate(item.release_date_world) || item.year }}</span>
                        </b-media-body>
                      </b-media>
                    </div>

                    <div v-if="!franchises.length" class="text-muted">
                      Фильм не привязан к франшизам
                    </div>
                  </div>
                </div>
                <!--/ Франшизы -->

                <movie-posters-modal
                    v-if="movieDetail"
                    v-model="isPostersModalVisible"
                    :movie-id="movieDetail.id"
                    @updated="onMoviePostersUpdated"
                />
                <b-modal
                    v-model="isPosterZoomVisible"
                    :title="movieDetail.title"
                    size="xl"
                    centered
                    hide-footer
                >
                  <div class="text-center">
                    <b-img
                        :src="currentPosterFullView"
                        alt="Постер"
                        class="poster-zoom-img"
                        fluid
                    />
                  </div>
                </b-modal>
              </b-col>
              <b-col
                  cols="12"
                  md="9"
                  class="d-flex align-items-center justify-content-center mb-2 mb-md-0"
              >
                <b-card
                    class="col-md-12 col-12"
                >
                  <b-overlay
                      :show="isLoadingMovie"
                      rounded="sm"
                  >
                    <div class="d-flex justify-content-between align-items-start">
                      <h4 class="card-title">{{ movieType(movieDetail.type) }}</h4>
                      <div class="text-nowrap">
                        <b-button
                            variant="success"
                            size="sm"
                            class="mr-50"
                            @click="importMovie"
                        >
                          <feather-icon
                              icon="TvIcon"
                              class="mr-50"
                          />
                          <span class="align-middle">Инфо (КП Unoff)</span>
                        </b-button>
                        <b-button
                            variant="warning"
                            size="sm"
                            @click="importMovieKpDev"
                        >
                          <feather-icon
                              icon="VideoIcon"
                              class="mr-50"
                          />
                          <span class="align-middle">Инфо (КП.dev)</span>
                        </b-button>
                        <b-button
                            variant="outline-info"
                            size="sm"
                            class="ml-50"
                            v-b-tooltip.hover
                            :title="movieDetail.notion_id
                              ? 'Подтянуть название, списки и кластеры из Notion'
                              : 'Страницы в Notion ещё нет — создать и привязать'"
                            @click="syncNotion"
                        >
                          <feather-icon
                              :icon="movieDetail.notion_id ? 'RefreshCwIcon' : 'UploadCloudIcon'"
                              class="mr-50"
                          />
                          <span class="align-middle">Синк Notion</span>
                        </b-button>
                      </div>
                    </div>
                    <b-row>
                      <b-col md="12">
                        <div
                            v-if="movieDetail.tagline"
                            class="mt-2 mt-xl-0 pb-50"
                        >
                          <feather-icon
                              icon="MessageCircleIcon"
                              class="mr-75"
                          />
                          <span class="font-weight-bold">Слоган</span>
                          <span class="ml-50 font-italic">{{ movieDetail.tagline }}</span>
                        </div>

                        <b-row :class="movieDetail.tagline ? '' : 'mt-2 mt-xl-0'">
                          <b-col
                              cols="12"
                              lg="6"
                          >
                            <table class="w-100 movie-info-table">
                              <tr v-if="movieDetail.genres">
                                <th class="pb-50">
                                  <feather-icon
                                      icon="FilmIcon"
                                      class="mr-75"
                                  />
                                  <span class="font-weight-bold">Жанры</span>
                                </th>
                                <td class="pb-50 text-capitalize">
                                  {{ movieDetail.genres }}
                                </td>
                              </tr>
                              <tr v-if="movieDetail.animation !== null && movieDetail.animation !== undefined">
                                <th class="pb-50">
                                  <feather-icon
                                      icon="FilmIcon"
                                      class="mr-75"
                                  />
                                  <span class="font-weight-bold">Анимация</span>
                                </th>
                                <td class="pb-50 text-capitalize">
                                  {{ movieDetail.animation === 1 ? 'Да' : (movieDetail.animation === 2 ? 'Частично' : 'Нет') }}
                                </td>
                              </tr>
                              <tr v-if="movieDetail.countries">
                                <th class="pb-50">
                                  <feather-icon
                                      icon="GlobeIcon"
                                      class="mr-75"
                                  />
                                  <span class="font-weight-bold">Страны</span>
                                </th>
                                <td class="pb-50 text-capitalize">
                                  {{ movieDetail.countries }}
                                </td>
                              </tr>
                              <tr v-if="movieLength(movieDetail.length)">
                                <th class="pb-50">
                                  <feather-icon
                                      icon="ClockIcon"
                                      class="mr-75"
                                  />
                                  <span class="font-weight-bold">Длительность</span>
                                </th>
                                <td class="pb-50">
                                  {{ movieLength(movieDetail.length) }}
                                </td>
                              </tr>
                              <tr>
                                <th class="pb-50">
                                  <feather-icon
                                      icon="StarIcon"
                                      class="mr-75"
                                  />
                                  <span class="font-weight-bold">КП</span>
                                </th>
                                <td class="pb-50">
                                  <b-link v-if="movieDetail.kp_id" :href="`https://www.kinopoisk.ru/film/${movieDetail.kp_id}/`">
                                    {{ ratingFmt(movieDetail.rating_kp) }} <span class="small">{{ formatNumber(movieDetail.votes_kp) }}</span>
                                  </b-link>
                                  <span v-else>{{ ratingFmt(movieDetail.rating_kp) }} <span class="small">{{ formatNumber(movieDetail.votes_kp) }}</span></span>
                                  <feather-icon
                                      icon="TrendingUpIcon"
                                      class="ml-50 cursor-pointer text-primary"
                                      @click="openRatingHistory('rating')"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th class="pb-50">
                                  <feather-icon
                                      icon="FlagIcon"
                                      class="mr-75"
                                  />
                                  <span class="font-weight-bold">IMDB</span>
                                </th>
                                <td class="pb-50">
                                  <b-link v-if="movieDetail.imdb_id" :href="`https://www.imdb.com/title/${movieDetail.imdb_id}/`">
                                    {{ ratingFmt(movieDetail.rating_imdb) }} <span class="small">{{ formatNumber(movieDetail.votes_imdb) }}</span>
                                  </b-link>
                                  <span v-else>{{ ratingFmt(movieDetail.rating_imdb) }} <span class="small">{{ formatNumber(movieDetail.votes_imdb) }}</span></span>
                                  <feather-icon
                                      icon="TrendingUpIcon"
                                      class="ml-50 cursor-pointer text-primary"
                                      @click="openRatingHistory('rating')"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th class="pb-50 align-top">
                                  <feather-icon
                                      icon="LinkIcon"
                                      class="mr-75"
                                  />
                                  <span class="font-weight-bold">Внешние ID</span>
                                </th>
                                <td class="pb-50">
                                  <div class="d-flex flex-wrap align-items-center" style="gap: 4px;">
                                    <template v-for="source in externalSources">
                                      <span
                                          v-if="externalId(source.key)"
                                          :key="'external-' + source.key"
                                          class="d-inline-flex align-items-center"
                                      >
                                        <b-badge
                                            tag="a"
                                            :variant="'light-' + source.color"
                                            class="font-small-2"
                                            :href="externalUrl(source.key)"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style="cursor: pointer; border-top-right-radius: 0; border-bottom-right-radius: 0;"
                                        >
                                          {{ source.label }}: {{ externalTitle(source.key) }}
                                          <feather-icon icon="ExternalLinkIcon" size="11" class="ml-25" />
                                        </b-badge>
                                        <b-button
                                            v-if="$can('manage', 'db-movies') && source.key !== 'kinopoisk'"
                                            variant="flat-danger"
                                            class="btn-icon p-0"
                                            size="sm"
                                            style="line-height: 1; margin-left: -2px;"
                                            @click="deleteExternalId(source)"
                                        >
                                          <feather-icon icon="XIcon" size="12" />
                                        </b-button>
                                      </span>
                                      <b-button
                                          v-else
                                          :key="'search-' + source.key"
                                          :disabled="!$can('manage', 'db-movies') || searchingExternalSource !== null"
                                          :variant="'outline-' + source.color"
                                          size="sm"
                                          class="py-25 px-50 font-small-2"
                                          @click="searchExternalId(source)"
                                      >
                                        <b-spinner v-if="searchingExternalSource === source.key" small class="mr-25" />
                                        <feather-icon v-else icon="SearchIcon" size="11" class="mr-25" />
                                        {{ source.label }}
                                      </b-button>
                                    </template>
                                    <b-button
                                        v-if="$can('manage', 'db-movies')"
                                        v-b-tooltip.hover
                                        title="Добавить по ссылке"
                                        variant="flat-primary"
                                        class="btn-icon p-25"
                                        size="sm"
                                        @click="showAddExternalIdModal = true"
                                    >
                                      <feather-icon icon="PlusCircleIcon" size="14"/>
                                    </b-button>
                                  </div>
                                  <b-modal
                                      v-model="showAddExternalIdModal"
                                      title="Добавить внешний ID"
                                      ok-title="Добавить"
                                      cancel-title="Отмена"
                                      centered
                                      :ok-disabled="!externalIdInput.trim() || isAddingExternalId"
                                      :busy="isAddingExternalId"
                                      @ok.prevent="addExternalId"
                                      @hidden="externalIdInput = ''"
                                  >
                                    <b-form-group
                                        label="Ссылка"
                                        description="Кинопоиск, IMDb или TMDb (themoviedb.org/movie|tv/…); IMDb можно указать как tt1234567"
                                    >
                                      <b-form-input
                                          v-model="externalIdInput"
                                          placeholder="https://www.kinopoisk.ru/film/..."
                                          autofocus
                                          @keyup.enter="addExternalId"
                                      />
                                    </b-form-group>
                                  </b-modal>
                                </td>
                              </tr>
                            </table>
                          </b-col>
                          <b-col
                              cols="12"
                              lg="6"
                          >
                            <table class="w-100 movie-info-table">
                              <tr v-if="movieDetail.release_date_world">
                                <th class="pb-50">
                                  <feather-icon
                                      icon="CalendarIcon"
                                      class="mr-75"
                                  />
                                  <span class="font-weight-bold">Премьера (мир)</span>
                                </th>
                                <td class="pb-50">
                                  {{ formatDate(movieDetail.release_date_world) }}
                                </td>
                              </tr>
                              <tr v-if="movieDetail.release_date_ru">
                                <th class="pb-50">
                                  <feather-icon
                                      icon="CalendarIcon"
                                      class="mr-75"
                                  />
                                  <span class="font-weight-bold">Премьера (РФ)</span>
                                </th>
                                <td class="pb-50">
                                  {{ formatDate(movieDetail.release_date_ru) }}
                                </td>
                              </tr>
                              <tr v-if="movieDetail.release_date_digital">
                                <th class="pb-50">
                                  <feather-icon
                                      icon="MonitorIcon"
                                      class="mr-75"
                                  />
                                  <span class="font-weight-bold">Цифровой релиз</span>
                                </th>
                                <td class="pb-50">
                                  {{ formatDate(movieDetail.release_date_digital) }}
                                </td>
                              </tr>
                              <tr v-if="movieDetail.updated_at">
                                <th class="pb-50">
                                  <feather-icon
                                      icon="RefreshCwIcon"
                                      class="mr-75"
                                  />
                                  <span class="font-weight-bold">Обновлено</span>
                                </th>
                                <td class="pb-50">
                                  {{ formatDateTime(movieDetail.updated_at) }}
                                </td>
                              </tr>
                              <tr v-if="movieDetail.is_serial && movieDetail.start_year">
                                <th class="pb-50">
                                  <feather-icon
                                      icon="TvIcon"
                                      class="mr-75"
                                  />
                                  <span class="font-weight-bold">Годы выхода</span>
                                </th>
                                <td class="pb-50">
                                  {{ movieDetail.start_year }}–{{ movieDetail.end_year || '…' }}
                                </td>
                              </tr>
                              <tr v-if="movieDetail.is_serial">
                                <th class="pb-50">
                                  <feather-icon
                                      icon="CheckCircleIcon"
                                      class="mr-75"
                                  />
                                  <span class="font-weight-bold">Статус</span>
                                </th>
                                <td class="pb-50">
                                  {{ movieDetail.is_completed ? 'Завершён' : 'Выходит' }}
                                </td>
                              </tr>
                              <tr v-if="movieDetail.kp_synced_at">
                                <th class="pb-50">
                                  <feather-icon
                                      icon="DownloadCloudIcon"
                                      class="mr-75"
                                  />
                                  <span class="font-weight-bold">Синхр. с КП</span>
                                </th>
                                <td class="pb-50">
                                  {{ formatDateTime(movieDetail.kp_synced_at) }}
                                </td>
                              </tr>
                            </table>
                          </b-col>
                        </b-row>

                        <!-- Сложность и кластеры (как на деталке артиста) -->
                        <div
                            class="d-flex flex-wrap align-items-center mt-75 pt-75 mb-1"
                            style="gap: 0.5rem 1.5rem; border-top: 1px solid rgba(115, 103, 240, 0.1);"
                        >
                          <div class="d-flex align-items-center">
                            <span class="text-muted font-small-3 mr-50">Сложность:</span>
                            <b-form-rating
                                :value="movieDetail.difficulty_rating"
                                :stars="10"
                                inline
                                no-border
                                size="sm"
                                variant="warning"
                                class="p-0"
                                :readonly="!$can('manage', 'db-movies')"
                                @change="updateDifficultyRating"
                            />
                            <span
                                v-if="movieDetail.calculated_difficulty != null"
                                class="text-muted ml-50"
                                style="font-size: 1.285rem;"
                                v-b-tooltip.hover
                                title="Расчётная сложность"
                            >({{ movieDetail.calculated_difficulty }})</span>
                            <span v-if="movieDetail.difficulty_rating == null" class="text-muted font-small-3 ml-50">не задана</span>
                          </div>
                          <div class="d-flex align-items-center ml-md-auto" style="gap: 0.75rem;">
                            <rating-stats-block
                                :rating="movieDetail.difficulty_rating"
                                :calculated="movieDetail.calculated_difficulty"
                            />
                            <b-button
                                v-if="$can('manage', 'db-movies')"
                                variant="flat-secondary"
                                class="btn-icon"
                                size="sm"
                                :disabled="recalcDifficultyLoading"
                                v-b-tooltip.hover
                                title="Пересчитать расчётную сложность по голосам КП и IMDb"
                                @click="recalculateDifficulty"
                            >
                              <b-spinner v-if="recalcDifficultyLoading" small />
                              <feather-icon v-else icon="SlidersIcon" size="14" />
                            </b-button>
                          </div>
                          <div class="d-flex align-items-center">
                            <span class="text-muted font-small-3 mr-50">Кластер:</span>
                            <v-select
                                v-model="selectedClusterIds"
                                :options="clusterOptions"
                                :reduce="o => o.id"
                                label="title"
                                multiple
                                :disabled="!$can('manage', 'db-movies') || isSavingClusters"
                                placeholder="—"
                                style="min-width: 220px"
                                @input="saveClusters"
                            />
                            <b-spinner v-if="isSavingClusters" small class="ml-50"/>
                          </div>
                        </div>

                        <div v-if="isSerialMovie" class="mt-1 mb-1">
                          <div class="d-flex align-items-center justify-content-between mb-50">
                            <div class="d-flex align-items-center">
                              <h6 class="mb-0">Каналы</h6>
                              <b-button
                                  variant="flat-secondary"
                                  size="sm"
                                  class="btn-icon ml-25"
                                  @click="isEditingChannels = !isEditingChannels"
                              >
                                <feather-icon :icon="isEditingChannels ? 'CheckIcon' : 'Edit2Icon'" />
                              </b-button>
                            </div>
                            <b-button
                                variant="outline-secondary"
                                size="sm"
                                :disabled="isLoadingChannelsFromTmdb"
                                @click="loadChannelsFromTmdb"
                            >
                              <b-spinner v-if="isLoadingChannelsFromTmdb" small class="mr-50" />
                              <feather-icon v-else icon="DownloadCloudIcon" class="mr-50" />
                              <span>Из TMDb</span>
                            </b-button>
                          </div>
                          <v-select
                              v-if="isEditingChannels"
                              v-model="movieChannels"
                              :options="allChannels"
                              label="name"
                              multiple
                              placeholder="Выбрать каналы..."
                              @input="saveChannels"
                          />
                          <div v-else-if="movieChannels.length" class="d-flex flex-wrap">
                            <b-badge
                                v-for="channel in movieChannels"
                                :key="channel.id"
                                variant="light-secondary"
                                class="mr-50 mb-25 channel-badge"
                            >
                              <b-img
                                  v-if="channel.logo"
                                  :src="channel.logo"
                                  class="channel-badge-logo mr-25"
                              />
                              {{ channel.name }}
                            </b-badge>
                          </div>
                          <div v-else class="text-muted small">Не указаны</div>
                        </div>

                        <b-tabs
                            pills
                        >
                          <!-- Tab: Актеры -->
                          <b-tab active>
                            <template #title>
                              <feather-icon
                                  icon="UserIcon"
                                  size="16"
                                  class="mr-0 mr-sm-50"
                              />
                              <span class="d-none d-sm-inline">Актеры</span>
                            </template>

                            <div class="my-1 py-25">
                              <div class="d-flex justify-content-end mb-50">
                                <b-button
                                    variant="outline-primary"
                                    size="sm"
                                    @click="importStaff"
                                >
                                  <feather-icon
                                      icon="UsersIcon"
                                      class="mr-50"
                                  />
                                  <span class="align-middle">Персоны</span>
                                </b-button>
                              </div>
                              <person-row
                                  v-for="actor in visibleActors"
                                  :key="actor.staffId"
                                  :person="actor"
                                  @refresh="refreshData"
                                  @block="blockData"
                              ></person-row>
                              <div
                                  v-if="movieDetail.actors && movieDetail.actors.length > 10"
                                  class="mt-1"
                              >
                                <b-link @click="showAllActors = !showAllActors">
                                  {{ showAllActors ? 'Скрыть всех' : 'Показать все' }}
                                </b-link>
                              </div>
                            </div>
                          </b-tab>

                          <!-- Tab: Режиссеры -->
                          <b-tab>
                            <template #title>
                              <feather-icon
                                  icon="InfoIcon"
                                  size="16"
                                  class="mr-0 mr-sm-50"
                              />
                              <span class="d-none d-sm-inline">Режиссеры</span>
                            </template>

                            <div class="my-1 py-25">
                              <person-row
                                  v-for="director in movieDetail.directors"
                                  :key="director.staffId"
                                  :person="director"
                                  @refresh="refreshData"
                                  @block="blockData"
                              ></person-row>
                            </div>
                          </b-tab>
                          <!-- Tab: Вопросы -->
                          <b-tab>
                            <template #title>
                              <feather-icon
                                  icon="Share2Icon"
                                  size="16"
                                  class="mr-0 mr-sm-50"
                              />
                              <span class="d-none d-sm-inline">Вопросы</span>
                            </template>

                            <div class="my-1 py-25">
                            <span
                                v-for="theme in movieDetail.themes"
                                :key="theme.id"
                            >
                              <b-button
                                  v-if="theme.question"
                                  :to="{ name: 'question-edit', params: { id: theme.question.id } }"
                                  variant="success"
                                  class="mr-75 mb-1"
                              >
                                  {{ theme.name }}
                              </b-button>
                              <b-button
                                  v-else-if="theme.template"
                                  :to="{ name: theme.template, params: { movie_id: movieDetail.id } }"
                                  variant="warning"
                                  class="mr-75 mb-1"
                              >
                                  {{ theme.name }}
                              </b-button>
                            </span>
                            </div>
                          </b-tab>
                          <!-- Tab: Кадры -->
                          <b-tab @click="fetchFrames">
                            <template #title>
                              <feather-icon
                                  icon="ImageIcon"
                                  size="16"
                                  class="mr-0 mr-sm-50"
                              />
                              <span class="d-none d-sm-inline">Кадры</span>
                              <b-badge
                                  v-if="movieDetail.frames_count"
                                  variant="success"
                                  pill
                                  class="ml-50"
                              >
                                {{ movieDetail.frames_count }}
                              </b-badge>
                            </template>

                            <div class="my-1 py-25">
                              <div class="d-flex justify-content-end align-items-center mb-1">
                                <div>
                                  <b-button
                                      variant="outline-secondary"
                                      size="sm"
                                      class="mr-50"
                                      :disabled="isLoadingPreview"
                                      @click="fetchPreviewFrames('kp')"
                                  >
                                    <feather-icon icon="FilmIcon" class="mr-50" />
                                    <span>Кинопоиск</span>
                                  </b-button>
                                  <b-button
                                      variant="outline-secondary"
                                      size="sm"
                                      :disabled="isLoadingPreview"
                                      @click="fetchPreviewFrames('imdb')"
                                  >
                                    <feather-icon icon="GlobeIcon" class="mr-50" />
                                    <span>IMDb</span>
                                  </b-button>
                                </div>
                              </div>

                              <div v-if="isLoadingPreview" class="text-center mb-2">
                                <b-spinner label="Loading..." />
                              </div>
                              <div v-else-if="previewSource" class="mb-2">
                                <div class="d-flex justify-content-between align-items-center flex-wrap mb-1">
                                  <h6 class="mb-50 mr-1">
                                    Превью из {{ previewSourceTitle }} ({{ framesPreview.length }})
                                  </h6>
                                  <div class="d-flex align-items-center flex-wrap">
                                    <b-button
                                        variant="outline-secondary"
                                        size="sm"
                                        class="mr-50 mb-50"
                                        @click="selectAllPreviewFrames"
                                    >
                                      Выбрать все
                                    </b-button>
                                    <b-button
                                        variant="outline-secondary"
                                        size="sm"
                                        class="mr-50 mb-50"
                                        :disabled="!selectedPreviewIds.length"
                                        @click="clearPreviewSelection"
                                    >
                                      Снять выбор
                                    </b-button>
                                    <b-button
                                        variant="primary"
                                        size="sm"
                                        class="mr-50 mb-50"
                                        :disabled="!selectedPreviewIds.length || isDownloadingFrames"
                                        @click="downloadSelectedFrames"
                                    >
                                      <b-spinner v-if="isDownloadingFrames" small class="mr-50" />
                                      <feather-icon v-else icon="DownloadIcon" class="mr-50" />
                                      <span>Скачать выбранные ({{ selectedPreviewIds.length }})</span>
                                    </b-button>
                                    <b-button
                                        variant="flat-secondary"
                                        size="sm"
                                        class="btn-icon mb-50"
                                        @click="closePreview"
                                    >
                                      <feather-icon icon="XIcon" />
                                    </b-button>
                                  </div>
                                </div>
                                <div v-if="framesPreview.length" class="frames-grid">
                                  <div
                                      v-for="frame in framesPreview"
                                      :key="frame.external_id"
                                      class="frame-item-wrapper"
                                  >
                                    <div
                                        class="frame-item"
                                        :class="{'frame-item-selected': isPreviewFrameSelected(frame)}"
                                        @click="togglePreviewFrameSelection(frame, $event)"
                                    >
                                      <b-img
                                          :src="frame.preview_url || frame.url"
                                          class="frame-img"
                                          :class="{'grayscale': frame.exists}"
                                          loading="lazy"
                                      />
                                    </div>
                                    <b-badge
                                        v-if="frame.exists"
                                        variant="secondary"
                                        class="frame-corner-badge"
                                    >
                                      В базе
                                    </b-badge>
                                    <div
                                        v-else-if="isPreviewFrameSelected(frame)"
                                        class="frame-selected-check"
                                    >
                                      <feather-icon icon="CheckIcon" size="14" />
                                    </div>
                                  </div>
                                </div>
                                <div v-else class="text-center">
                                  Источник не вернул кадров
                                </div>
                                <hr>
                              </div>

                              <div v-if="isLoadingFrames" class="text-center">
                                <b-spinner label="Loading..." />
                              </div>
                              <div v-else-if="movieFrames && movieFrames.length" class="frames-grid">
                                <div
                                    v-for="(frame, index) in movieFrames"
                                    :key="index"
                                    class="frame-item-wrapper"
                                >
                                  <div
                                      class="frame-item"
                                      :class="{'border-danger': !frame.id}"
                                      @click="openFrame(frame)"
                                  >
                                    <b-img
                                        :src="frame.preview_url || frame.s3_url || frame.url"
                                        class="frame-img"
                                        :class="{'grayscale': frame.is_disabled}"
                                    />
                                  </div>
                                  <b-badge
                                      v-if="frame.s3_path"
                                      variant="light-info"
                                      class="frame-s3-badge"
                                  >
                                    S3
                                  </b-badge>
                                  <b-button
                                      v-if="frame.id"
                                      variant="flat-secondary"
                                      class="btn-icon rounded-circle frame-toggle-btn"
                                      size="sm"
                                      @click.stop="toggleFrame(movieDetail, frame)"
                                  >
                                    <feather-icon
                                        :icon="frame.is_disabled ? 'EyeOffIcon' : 'EyeIcon'"
                                        :class="{'text-danger': frame.is_disabled}"
                                    />
                                  </b-button>
                                  <b-button
                                      v-if="frame.id"
                                      variant="flat-danger"
                                      class="btn-icon rounded-circle frame-toggle-btn frame-delete-btn"
                                      size="sm"
                                      @click.stop="deleteFrame(frame)"
                                  >
                                    <feather-icon icon="TrashIcon" class="text-danger" />
                                  </b-button>
                                </div>
                              </div>
                              <div v-else class="text-center">
                                Нет доступных кадров
                              </div>
                            </div>
                          </b-tab>

                          <!-- Tab: Сиквелы и приквелы -->
                          <b-tab @click="() => fetchSequels()">
                            <template #title>
                              <feather-icon
                                  icon="GitBranchIcon"
                                  size="16"
                                  class="mr-0 mr-sm-50"
                              />
                              <span class="d-none d-sm-inline">Сиквелы и приквелы</span>
                            </template>

                            <div class="my-1 py-25">
                              <div v-if="sequels && sequels.length">
                                <b-media
                                    v-for="(movie,index) in sequels"
                                    :key="movie.filmId"
                                    no-body
                                    :class="index? 'mt-2':''"
                                >
                                  <b-media-aside class="mr-2">
                                    <b-link>
                                      <b-img
                                          :src="movie.posterUrlPreview"
                                          width="100"
                                          rounded
                                          height="70"
                                      />
                                    </b-link>
                                  </b-media-aside>
                                  <b-media-body>
                                    <h6 class="blog-recent-post-title">
                                      <b-link class="text-body-heading">
                                        <feather-icon
                                            :icon="sequelIcon(movie.relationType)"
                                            class="mr-25"
                                        />
                                        {{ movie.nameRu }}
                                      </b-link>
                                    </h6>
                                    <span class="text-muted mb-0" v-if="movie.db">
                                      {{ formatDate(movie.db.release_date_ru) }}
                                    </span>

                                    <div class="text-nowrap">
                                      <b-button
                                          v-if="!movie.db"
                                          variant="success"
                                          class="btn-icon"
                                          size="sm"
                                          @click="addMovie(movie)"
                                          :disabled="movie.loading"
                                      >
                                        <feather-icon icon="UserPlusIcon"/>
                                      </b-button>
                                      <b-button
                                          v-else
                                          :to="{name: 'movie-view', params: { id: movie.db.id }}"
                                          variant="primary"
                                          class="btn-icon"
                                          size="sm"
                                      >
                                        <feather-icon icon="ArrowRightCircleIcon"/>
                                      </b-button>
                                      <b-button
                                          :href="`https://kinopoisk.ru/film/${movie.filmId}`"
                                          variant="warning"
                                          class="btn-icon ml-1"
                                          size="sm"
                                      >
                                        <feather-icon icon="CastIcon"/>
                                      </b-button>
                                    </div>
                                  </b-media-body>
                                </b-media>
                              </div>
                              <div v-else class="text-center text-muted">
                                Нет данных о сиквелах и приквелах
                              </div>
                            </div>
                          </b-tab>

                          <!-- Tab: Сезоны -->
                          <b-tab v-if="isSerialMovie" @click="() => fetchSeasons()">
                            <template #title>
                              <feather-icon icon="LayersIcon" size="16" class="mr-0 mr-sm-50" />
                              <span class="d-none d-sm-inline">Сезоны</span>
                              <b-badge
                                  v-if="seasonsLoaded ? seasons.length : movieDetail.seasons_count"
                                  variant="success"
                                  pill
                                  class="ml-50"
                              >
                                {{ seasonsLoaded ? seasons.length : movieDetail.seasons_count }}
                              </b-badge>
                            </template>
                            <div class="my-1 py-25">
                              <div class="d-flex justify-content-end mb-1">
                                <b-button variant="outline-primary" size="sm" :disabled="isLoadingKpExtras" @click="loadKpExtras">
                                  Дозагрузить из КП
                                </b-button>
                              </div>
                              <b-overlay :show="isLoadingSeasons || isLoadingKpExtras" rounded="sm">
                                <div v-if="seasonsLoaded && !seasons.length" class="text-muted">
                                  Нет данных о сезонах — попробуйте «Дозагрузить из КП»
                                </div>
                                <b-card v-for="season in seasons" :key="season.number" no-body class="mb-1 border">
                                  <b-card-header class="py-75">
                                    <h5 class="mb-0">Сезон {{ season.number }} <span class="text-muted">— серий: {{ season.episodes_count }}</span></h5>
                                  </b-card-header>
                                  <b-table
                                      :items="season.episodes"
                                      :fields="episodeFields"
                                      small
                                      striped
                                      responsive
                                  />
                                </b-card>
                              </b-overlay>
                            </div>
                          </b-tab>

                          <!-- Tab: Видео -->
                          <b-tab @click="() => fetchVideos()">
                            <template #title>
                              <feather-icon icon="YoutubeIcon" size="16" class="mr-0 mr-sm-50" />
                              <span class="d-none d-sm-inline">Видео</span>
                              <b-badge
                                  v-if="videosLoaded ? videos.length : movieDetail.videos_count"
                                  variant="success"
                                  pill
                                  class="ml-50"
                              >
                                {{ videosLoaded ? videos.length : movieDetail.videos_count }}
                              </b-badge>
                            </template>
                            <div class="my-1 py-25">
                              <div class="d-flex justify-content-end mb-1">
                                <b-button variant="outline-primary" size="sm" :disabled="isLoadingKpExtras" @click="loadKpExtras">
                                  Дозагрузить из КП
                                </b-button>
                              </div>
                              <b-overlay :show="isLoadingVideos || isLoadingKpExtras" rounded="sm">
                                <div v-if="videosLoaded && !videos.length" class="text-muted">
                                  Нет видео — попробуйте «Дозагрузить из КП»
                                </div>
                                <b-list-group>
                                  <b-list-group-item
                                      v-for="(video, index) in videos"
                                      :key="index"
                                      class="d-flex align-items-center justify-content-between"
                                  >
                                    <a :href="video.url" target="_blank" rel="noopener">{{ video.name || video.url }}</a>
                                    <b-badge variant="light-secondary">{{ video.site }}</b-badge>
                                  </b-list-group-item>
                                </b-list-group>
                              </b-overlay>
                            </div>
                          </b-tab>

                          <!-- Tab: Награды -->
                          <b-tab @click="() => fetchAwards()">
                            <template #title>
                              <feather-icon icon="AwardIcon" size="16" class="mr-0 mr-sm-50" />
                              <span class="d-none d-sm-inline">Награды</span>
                              <b-badge
                                  v-if="awardsLoaded ? awards.length : movieDetail.awards_count"
                                  variant="success"
                                  pill
                                  class="ml-50"
                              >
                                {{ awardsLoaded ? awards.length : movieDetail.awards_count }}
                              </b-badge>
                            </template>
                            <div class="my-1 py-25">
                              <div class="d-flex justify-content-end mb-1">
                                <b-button variant="outline-primary" size="sm" :disabled="isLoadingKpExtras" @click="loadKpExtras">
                                  Дозагрузить из КП
                                </b-button>
                              </div>
                              <b-overlay :show="isLoadingAwards || isLoadingKpExtras" rounded="sm">
                                <div v-if="awardsLoaded && !awards.length" class="text-muted">
                                  Нет наград — попробуйте «Дозагрузить из КП»
                                </div>
                                <b-card v-for="group in awardsGrouped" :key="group.key" no-body class="mb-1 border">
                                  <b-card-header class="py-75">
                                    <h5 class="mb-0">{{ group.name }} <span class="text-muted">({{ group.year }})</span></h5>
                                  </b-card-header>
                                  <b-list-group flush>
                                    <b-list-group-item v-for="(award, index) in group.items" :key="index">
                                      <b-badge :variant="award.win ? 'light-success' : 'light-secondary'" class="mr-50">
                                        {{ award.win ? 'Победа' : 'Номинация' }}
                                      </b-badge>
                                      {{ award.nomination_name }}
                                      <span v-if="award.persons && award.persons.length" class="text-muted">
                                        — {{ award.persons.map(person => person.nameRu || person.nameEn).filter(Boolean).join(', ') }}
                                      </span>
                                    </b-list-group-item>
                                  </b-list-group>
                                </b-card>
                              </b-overlay>
                            </div>
                          </b-tab>

                          <!-- Tab: Списки -->
                          <b-tab>
                            <template #title>
                              <feather-icon
                                  icon="Share2Icon"
                                  size="16"
                                  class="mr-0 mr-sm-50"
                              />
                              <span class="d-none d-sm-inline">Списки</span>
                              <b-badge variant="success" class="ml-50">
                                {{ movieDetail.lists_count || 0 }}
                              </b-badge>
                            </template>

                            <div class="my-1 py-25">
                              <b-table
                                  :items="movieDetail.lists || []"
                                  :fields="movieListsColumns"
                                  responsive
                                  show-empty
                                  empty-text="Списков нет"
                                  class="position-relative"
                              >
                                <template #cell(title)="data">
                                  <router-link
                                      :to="{ name: 'list-view', params: { id: data.item.id } }"
                                  >
                                    {{ data.item.title }}
                                  </router-link>
                                </template>

                                <template #cell(items_count)="data">
                                  <b-badge variant="light-primary">
                                    {{ data.item.items_count }}
                                  </b-badge>
                                </template>

                                <template #cell(auto)="data">
                                  <b-badge :variant="data.item.auto ? 'light-success' : 'light-secondary'">
                                    {{ data.item.auto ? 'да' : '—' }}
                                  </b-badge>
                                </template>

                                <template #cell(autotopics)="data">
                                  <div
                                      v-if="(data.item.autotopics || []).length"
                                      class="d-flex flex-wrap"
                                  >
                                    <b-badge
                                        v-for="autotopic in data.item.autotopics"
                                        :key="autotopic.id"
                                        variant="light-info"
                                        class="mr-50 mb-25"
                                    >
                                      {{ autotopic.title }}
                                    </b-badge>
                                  </div>
                                  <b-badge
                                      v-else
                                      variant="light-secondary"
                                  >
                                    свободный
                                  </b-badge>
                                </template>
                              </b-table>
                            </div>
                          </b-tab>

                          <!-- Tab: Опенинги (только сериалы) -->
                          <b-tab v-if="isSerialMovie" lazy>
                            <template #title>
                              <feather-icon icon="TvIcon" size="16" class="mr-0 mr-sm-50" />
                              <span class="d-none d-sm-inline">Опенинги</span>
                            </template>
                            <movie-media-tab
                                :movie-id="movieDetail.id"
                                category="opening"
                                :sections="[
                                  {type: 'audio', title: 'Аудио'},
                                  {type: 'image', title: 'Кадры'},
                                  {type: 'video', title: 'Видео'},
                                ]"
                            />
                          </b-tab>

                          <!-- Tab: Титры (только фильмы) -->
                          <b-tab v-if="!isSerialMovie" lazy>
                            <template #title>
                              <feather-icon icon="ListIcon" size="16" class="mr-0 mr-sm-50" />
                              <span class="d-none d-sm-inline">Титры</span>
                            </template>
                            <movie-media-tab
                                :movie-id="movieDetail.id"
                                category="credits"
                                :sections="[
                                  {type: 'image', title: 'Кадры'},
                                  {type: 'video', title: 'Видео'},
                                ]"
                            />
                          </b-tab>

                          <!-- Tab: Саундтреки (только фильмы) -->
                          <b-tab v-if="!isSerialMovie" lazy>
                            <template #title>
                              <feather-icon icon="MusicIcon" size="16" class="mr-0 mr-sm-50" />
                              <span class="d-none d-sm-inline">Саундтреки</span>
                              <b-badge
                                  v-if="soundtracksLoaded ? soundtracksCount : movieDetail.soundtracks_count"
                                  variant="success"
                                  pill
                                  class="ml-50"
                              >
                                {{ soundtracksLoaded ? soundtracksCount : movieDetail.soundtracks_count }}
                              </b-badge>
                            </template>
                            <movie-soundtrack-tab :movie-id="movieDetail.id" :movie-title="movieDetail.title_ru || movieDetail.title_en || ''" @updated="onSoundtracksUpdated" />
                          </b-tab>

                          <!-- Tab: Песни из фильма (только фильмы) -->
                          <b-tab v-if="!isSerialMovie" lazy>
                            <template #title>
                              <feather-icon icon="DiscIcon" size="16" class="mr-0 mr-sm-50" />
                              <span class="d-none d-sm-inline">Песни</span>
                            </template>
                            <movie-media-tab
                                :movie-id="movieDetail.id"
                                category="song"
                                :sections="[{type: 'audio', title: 'Аудио'}]"
                            />
                          </b-tab>

                          <!-- Tab: Танцы (только фильмы) -->
                          <b-tab v-if="!isSerialMovie" lazy>
                            <template #title>
                              <feather-icon icon="ActivityIcon" size="16" class="mr-0 mr-sm-50" />
                              <span class="d-none d-sm-inline">Танцы</span>
                            </template>
                            <movie-media-tab
                                :movie-id="movieDetail.id"
                                category="dance"
                                :sections="[{type: 'video', title: 'Видео'}]"
                            />
                          </b-tab>

                          <!-- Tab: Трейлеры (аудио) (только фильмы) -->
                          <b-tab v-if="!isSerialMovie" lazy>
                            <template #title>
                              <feather-icon icon="VolumeIcon" size="16" class="mr-0 mr-sm-50" />
                              <span class="d-none d-sm-inline">Трейлеры (аудио)</span>
                            </template>
                            <trailer-audio-extractor
                                :movie-id="movieDetail.id"
                                @saved="onTrailerAudioSaved"
                            />
                            <movie-media-tab
                                :key="trailerMediaKey"
                                :movie-id="movieDetail.id"
                                category="trailer"
                                :sections="[{type: 'audio', title: 'Аудио'}]"
                            />
                          </b-tab>

                          <!-- Tab: Диалоги (только фильмы) -->
                          <b-tab v-if="!isSerialMovie" lazy>
                            <template #title>
                              <feather-icon icon="MessageCircleIcon" size="16" class="mr-0 mr-sm-50" />
                              <span class="d-none d-sm-inline">Диалоги</span>
                            </template>
                            <dialogue-audio-extractor
                                :movie-id="movieDetail.id"
                                :movie-title="movieDetail.title_ru || movieDetail.title_en || ''"
                                @saved="onDialogueAudioSaved"
                            />
                            <movie-media-tab
                                :key="dialogueMediaKey"
                                :movie-id="movieDetail.id"
                                category="dialogue"
                                :sections="[{type: 'audio', title: 'Аудио'}]"
                            />
                          </b-tab>
                        </b-tabs>

                        <b-modal
                            v-model="isFrameModalVisible"
                            size="xl"
                            hide-footer
                            centered
                            class="frame-modal"
                            title="Просмотр кадра"
                        >
                          <div v-if="selectedFrame" class="text-center position-relative">
                            <b-img
                                :src="selectedFrame.s3_url || selectedFrame.url"
                                fluid
                                class="rounded"
                                :class="{'grayscale': selectedFrame.is_disabled}"
                            />
                            <b-button
                                v-if="selectedFrame.id"
                                variant="primary"
                                class="btn-icon rounded-circle frame-modal-toggle-btn"
                                @click="toggleFrame(movieDetail, selectedFrame)"
                            >
                              <feather-icon
                                  :icon="selectedFrame.is_disabled ? 'EyeOffIcon' : 'EyeIcon'"
                                  size="24"
                                  :class="{'text-danger': selectedFrame.is_disabled}"
                              />
                            </b-button>
                          </div>
                        </b-modal>

                        <movie-rating-history-modal
                            v-if="movieDetail"
                            v-model="isRatingHistoryVisible"
                            :movie-id="movieDetail.id"
                            :mode="ratingHistoryMode"
                        />

                        <b-modal
                            v-model="isFranchiseModalVisible"
                            title="Привязать к франшизе"
                            centered
                            ok-title="Привязать"
                            cancel-title="Отмена"
                            :ok-disabled="!selectedFranchiseOption"
                            @ok.prevent="submitFranchiseAttach"
                        >
                          <b-form-group label="Франшиза">
                            <v-select
                                v-model="selectedFranchiseOption"
                                :options="franchiseOptions"
                                label="title"
                                taggable
                                :filterable="false"
                                :create-option="text => ({ title: text })"
                                placeholder="Начните вводить название"
                                @search="onFranchiseSearch"
                            />
                            <small class="text-muted">
                              Если франшизы нет в списке — введите название и нажмите Enter, она будет создана
                            </small>
                          </b-form-group>
                          <b-form-group label="Номер части (необязательно)">
                            <b-form-input
                                v-model.number="franchisePartNumber"
                                type="number"
                                min="1"
                            />
                          </b-form-group>
                        </b-modal>
                      </b-col>
                    </b-row>
                  </b-overlay>
                </b-card>
              </b-col>
            </b-row>

            <p
                v-if="movieDetail.short_description"
                class="font-italic text-muted"
            >
              {{ movieDetail.short_description }}
            </p>

            <!-- eslint-disable vue/no-v-html -->
            <div
                class="blog-content"
                v-html="movieDetail.description"
            />
            <!-- eslint-enable -->
          </b-card>
        </b-col>
        <!--/ blogs -->
      </b-row>
      <!--/ blogs -->
    </div>
    <!--/ content -->
  </div>
</template>

<script>
import {
  BMedia,
  BMediaAside,
  BMediaBody,
  BImg,
  BLink,
  BCard,
  BRow,
  BCol,
  BBadge,
  BButton,
  BTab,
  BTabs,
  BSpinner,
  BOverlay,
  BModal,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormRating,
  BListGroup,
  BListGroupItem,
  BTable,
  BCardHeader,
  VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import {formatDate, ratingFmt, formatNumber, formatDateTime} from '@core/utils/filter'
import router from "@/router";
import store from "@/store";
import movieStoreModule from "@/views/database/movieStoreModule";
import {onUnmounted, ref, computed, watch} from "@vue/composition-api";
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PersonRow from "@/views/database/PersonRow";
import MovieRatingHistoryModal from '@/views/database/MovieRatingHistoryModal.vue'
import MovieMediaTab from '@/views/database/MovieMediaTab.vue'
import MovieSoundtrackTab from './MovieSoundtrackTab.vue'
import MoviePostersModal from '@/views/database/MoviePostersModal.vue'
import TrailerAudioExtractor from '@/views/database/TrailerAudioExtractor.vue'
import DialogueAudioExtractor from '@/views/database/DialogueAudioExtractor.vue'
import RatingStatsBlock from '@/views/db-music/RatingStatsBlock.vue'

export default {
  components: {
    PersonRow,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    BCard,
    BRow,
    BCol,
    BImg,
    BBadge,
    BButton,
    BTab,
    BTabs,
    BSpinner,
    BOverlay,
    BModal,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BFormRating,
    BListGroup,
    BListGroupItem,
    BTable,
    BCardHeader,
    vSelect,
    MovieRatingHistoryModal,
    MovieMediaTab,
    MovieSoundtrackTab,
    MoviePostersModal,
    TrailerAudioExtractor,
    DialogueAudioExtractor,
    RatingStatsBlock,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  methods: {
    sequelIcon(type) {
      if (type === 'REMAKE') return 'RefreshCcwIcon'
      if (type === 'PREQUEL') return 'ArrowLeftCircleIcon'
      if (type === 'SEQUEL') return 'ArrowRightCircleIcon'
      return 'LinkIcon'
    },
    movieType(type) {
      if (type === 'FILM') return 'Фильм'
      if (type === 'TV_SHOW') return 'ТВ-Шоу'
      if (type === 'TV_SERIES') return 'Сериал'
      if (type === 'MINI_SERIES') return 'Мини-сериал'
      if (type === 'VIDEO') return 'Видео'
      return 'Неизвестный тип'
    },
    movieLength(length) {
      if (!length || length.startsWith('00:00')) return null
      const [hours, minutes] = length.split(':').map(Number)
      if (!hours) return `${minutes} мин`
      return minutes ? `${hours} ч ${minutes} мин` : `${hours} ч`
    },
  },
  setup() {
    const STORE_MODULE_NAME = 'movies'
    const toast = useToast()

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, movieStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const movieDetail = ref(null)


    const externalSources = [
      { key: 'kinopoisk', label: 'КП', color: 'warning' },
      { key: 'imdb', label: 'IMDb', color: 'secondary' },
      { key: 'tmdb', label: 'TMDb', color: 'info' },
    ]
    const searchingExternalSource = ref(null)
    const showAddExternalIdModal = ref(false)
    const externalIdInput = ref('')
    const isAddingExternalId = ref(false)

    const externalId = key => ((movieDetail.value && movieDetail.value.external_ids) || {})[key] || null
    const externalTitle = key => ((movieDetail.value && movieDetail.value.external_titles) || {})[key] || externalId(key)
    const externalUrl = key => {
      const id = externalId(key)
      if (key === 'kinopoisk') return `https://www.kinopoisk.ru/film/${id}/`
      if (key === 'imdb') return `https://www.imdb.com/title/${id}/`
      return `https://www.themoviedb.org/${isSerialMovie.value ? 'tv' : 'movie'}/${id}`
    }

    // Колонки kp_id/imdb_id читают другие вкладки деталки — обновляем их вместе с блоком
    const applyExternals = data => {
      movieDetail.value = {
        ...movieDetail.value,
        external_ids: data.external_ids,
        external_titles: data.external_titles,
        kp_id: data.external_ids.kinopoisk !== null ? Number(data.external_ids.kinopoisk) : null,
        imdb_id: data.external_ids.imdb,
      }
    }

    const notifyExternal = (title, success) => {
      toast({
        component: ToastificationContent,
        props: { title, icon: success ? 'CheckIcon' : 'AlertTriangleIcon', variant: success ? 'success' : 'danger' },
      })
    }

    const searchExternalId = async source => {
      searchingExternalSource.value = source.key
      try {
        const response = await store.dispatch('movies/searchMovieExternalId', { id: movieDetail.value.id, source: source.key })
        applyExternals(response.data)
        notifyExternal(response.data.message, response.data.success)
      } catch (error) {
        notifyExternal(error.response?.data?.message || `Ошибка поиска: ${source.label}`, false)
      } finally {
        searchingExternalSource.value = null
      }
    }

    const addExternalId = async () => {
      if (isAddingExternalId.value) return
      const url = externalIdInput.value.trim()
      if (!url) return
      isAddingExternalId.value = true
      try {
        const response = await store.dispatch('movies/addMovieExternalId', { id: movieDetail.value.id, url })
        applyExternals(response.data)
        showAddExternalIdModal.value = false
        notifyExternal('Внешний ID привязан', true)
      } catch (error) {
        notifyExternal(error.response?.data?.message || 'Не удалось привязать', false)
      } finally {
        isAddingExternalId.value = false
      }
    }

    const deleteExternalId = async source => {
      try {
        const response = await store.dispatch('movies/deleteMovieExternalId', { id: movieDetail.value.id, source: source.key })
        applyExternals(response.data)
      } catch (error) {
        notifyExternal(error.response?.data?.message || 'Не удалось удалить', false)
      }
    }

    const sequels = ref([])
    const sequelsLoaded = ref(false)
    const isLoadingMovie = ref(false)
    const isLoadingStaff = ref(false)
    const disabledMovieId = ref(null)

    const movieFrames = ref([])
    const isLoadingFrames = ref(false)
    const isFrameModalVisible = ref(false)
    const selectedFrame = ref(null)

    // Превью кадров из внешних источников (Кинопоиск / IMDb)
    const framesPreview = ref([])
    const previewSource = ref(null)
    const isLoadingPreview = ref(false)
    const isDownloadingFrames = ref(false)
    const selectedPreviewIds = ref([])
    // Якорь для выбора диапазона по Shift — external_id последнего кликнутого кадра
    const lastClickedPreviewId = ref(null)
    const previewSourceTitle = computed(() => (previewSource.value === 'kp' ? 'Кинопоиска' : 'IMDb'))

    const isRatingHistoryVisible = ref(false)
    const ratingHistoryMode = ref('rating')
    const openRatingHistory = mode => {
      ratingHistoryMode.value = mode
      isRatingHistoryVisible.value = true
    }

    // Просмотр постеров: основной постер фильма + доп. постеры (чистый просмотр, movies.poster не меняется)
    const moviePosters = ref([])
    const posterViewIndex = ref(0)
    const isPostersModalVisible = ref(false)

    const posterViewList = computed(() => {
      if (!movieDetail.value) return []
      return [movieDetail.value.poster, ...moviePosters.value.map(poster => poster.preview_url || poster.s3_url || poster.url)]
          .filter(Boolean)
    })
    const currentPosterView = computed(() => posterViewList.value[posterViewIndex.value]
        || (movieDetail.value ? movieDetail.value.poster : null))

    // Полноразмерный просмотр в модалке: у доп. постеров превью уменьшенное, берём оригинал.
    // Цепочки фолбэков совпадают по полям с posterViewList, поэтому индексы после filter не расходятся
    const isPosterZoomVisible = ref(false)
    const posterViewFullList = computed(() => {
      if (!movieDetail.value) return []
      return [movieDetail.value.poster, ...moviePosters.value.map(poster => poster.s3_url || poster.url || poster.preview_url)]
          .filter(Boolean)
    })
    const currentPosterFullView = computed(() => posterViewFullList.value[posterViewIndex.value] || currentPosterView.value)

    const goPrevPosterView = () => {
      if (posterViewIndex.value > 0) posterViewIndex.value -= 1
    }
    const goNextPosterView = () => {
      if (posterViewIndex.value < posterViewList.value.length - 1) posterViewIndex.value += 1
    }

    const fetchMoviePosters = () => {
      store.dispatch('movies/fetchMoviePosters', {id: movieDetail.value.id})
          .then(response => {
            moviePosters.value = response.data.data
          })
          .catch(() => {})
    }

    // Модалка постеров сама ведёт список и присылает актуальный набор после каждого изменения
    const onMoviePostersUpdated = posters => {
      moviePosters.value = posters
      if (movieDetail.value) movieDetail.value.posters_count = posters.length
      if (posterViewIndex.value > posters.length) posterViewIndex.value = posters.length
    }

    const showAllActors = ref(false)
    const visibleActors = computed(() => {
      if (!movieDetail.value || !movieDetail.value.actors) return []
      if (showAllActors.value) return movieDetail.value.actors
      return movieDetail.value.actors.slice(0, 10)
    })

    const fetchFrames = (force = false) => {
      if (!force && movieFrames.value.length > 0) return
      isLoadingFrames.value = true
      let id = router.currentRoute.params.id
      store.dispatch('movies/fetchFrames', {id})
          .then(response => {
            movieFrames.value = response.data.data
            isLoadingFrames.value = false
          })
          .catch(() => {
            isLoadingFrames.value = false
          })
    }

    const openFrame = (frame) => {
      selectedFrame.value = frame
      isFrameModalVisible.value = true
    }

    const toggleFrame = (movie, frame) => {
      store.dispatch('movies/toggleFrame', {movie_id: movie.id, id: frame.id})
          .then(() => {
            frame.is_disabled = !frame.is_disabled
            toast({
              component: ToastificationContent,
              props: {
                title: `Кадр ${frame.is_disabled ? 'выключен' : 'включен'}`,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          })
          .catch(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Ошибка при изменении статуса кадра',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
    }

    const fetchPreviewFrames = source => {
      isLoadingPreview.value = true
      selectedPreviewIds.value = []
      lastClickedPreviewId.value = null
      let id = router.currentRoute.params.id
      store.dispatch('movies/previewFrames', {id, source})
          .then(response => {
            framesPreview.value = response.data.data
            previewSource.value = source
            isLoadingPreview.value = false
          })
          .catch(() => {
            isLoadingPreview.value = false
            toast({
              component: ToastificationContent,
              props: {
                title: 'Ошибка при загрузке превью кадров',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
    }

    const isPreviewFrameSelected = frame => selectedPreviewIds.value.includes(frame.external_id)

    const togglePreviewFrameSelection = (frame, event) => {
      if (frame.exists) return

      if (event && event.shiftKey && lastClickedPreviewId.value !== null && lastClickedPreviewId.value !== frame.external_id) {
        const frames = framesPreview.value
        const currentIndex = frames.findIndex(item => item.external_id === frame.external_id)
        const anchorIndex = frames.findIndex(item => item.external_id === lastClickedPreviewId.value)

        if (currentIndex !== -1 && anchorIndex !== -1) {
          const fromIndex = Math.min(currentIndex, anchorIndex)
          const toIndex = Math.max(currentIndex, anchorIndex)
          const rangeIds = frames
              .slice(fromIndex, toIndex + 1)
              .filter(item => !item.exists)
              .map(item => item.external_id)
          selectedPreviewIds.value = [...new Set([...selectedPreviewIds.value, ...rangeIds])]
          lastClickedPreviewId.value = frame.external_id
          return
        }
      }

      if (isPreviewFrameSelected(frame)) {
        selectedPreviewIds.value = selectedPreviewIds.value.filter(externalId => externalId !== frame.external_id)
      } else {
        selectedPreviewIds.value = [...selectedPreviewIds.value, frame.external_id]
      }
      lastClickedPreviewId.value = frame.external_id
    }

    const selectAllPreviewFrames = () => {
      selectedPreviewIds.value = framesPreview.value
          .filter(frame => !frame.exists)
          .map(frame => frame.external_id)
    }

    const clearPreviewSelection = () => {
      selectedPreviewIds.value = []
    }

    const closePreview = () => {
      framesPreview.value = []
      previewSource.value = null
      selectedPreviewIds.value = []
      lastClickedPreviewId.value = null
    }

    const downloadSelectedFrames = () => {
      const framesToDownload = framesPreview.value
          .filter(frame => selectedPreviewIds.value.includes(frame.external_id))
      if (!framesToDownload.length) return

      isDownloadingFrames.value = true
      let id = router.currentRoute.params.id
      store.dispatch('movies/downloadFrames', {
        id,
        frames: framesToDownload.map(frame => ({
          url: frame.url,
          preview_url: frame.preview_url,
          type: frame.type,
          external_id: frame.external_id,
          width: frame.width,
          height: frame.height,
        })),
      })
          .then(response => {
            const downloadedCount = response.data.data ? response.data.data.length : 0
            framesToDownload.forEach(frame => {
              frame.exists = true
            })
            selectedPreviewIds.value = []
            isDownloadingFrames.value = false
            toast({
              component: ToastificationContent,
              props: {
                title: `Скачано кадров: ${downloadedCount}`,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            fetchFrames(true)
            fetchMovieData()
          })
          .catch(() => {
            isDownloadingFrames.value = false
            toast({
              component: ToastificationContent,
              props: {
                title: 'Ошибка при скачивании кадров',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
    }

    const deleteFrame = frame => {
      if (!window.confirm('Удалить кадр? Копия на S3 (если есть) тоже будет удалена.')) return
      store.dispatch('movies/deleteFrame', {movie_id: movieDetail.value.id, id: frame.id})
          .then(() => {
            movieFrames.value = movieFrames.value.filter(item => item.id !== frame.id)
            if (selectedFrame.value && selectedFrame.value.id === frame.id) {
              isFrameModalVisible.value = false
            }
            fetchMovieData()
            toast({
              component: ToastificationContent,
              props: {
                title: 'Кадр удалён',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          })
          .catch(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Ошибка при удалении кадра',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
    }

    const fetchSequels = (force = false) => {
      // Ленивая загрузка: КП дёргаем только при открытии таба
      if (!force && sequelsLoaded.value) return
      let id = router.currentRoute.params.id
      store.dispatch('movies/fetchMovieSequels', {id})
          .then(response => {
            sequels.value = response.data
            sequelsLoaded.value = true
          })
    }

    // --- KP extras: сезоны, видео, награды ---
    const seasons = ref([])
    const seasonsLoaded = ref(false)
    const isLoadingSeasons = ref(false)
    const videos = ref([])
    const videosLoaded = ref(false)
    const isLoadingVideos = ref(false)
    const awards = ref([])
    const awardsLoaded = ref(false)
    const isLoadingAwards = ref(false)
    const isLoadingKpExtras = ref(false)

    // --- Саундтреки: счётчик бэджа вкладки обновляется событием из MovieSoundtrackTab ---
    const soundtracksCount = ref(0)
    const soundtracksLoaded = ref(false)

    const onSoundtracksUpdated = count => {
      soundtracksCount.value = count
      soundtracksLoaded.value = true
      if (movieDetail.value) movieDetail.value.soundtracks_count = count
    }

    // --- Трейлеры (аудио): перезагрузка списка после сохранения из TrailerAudioExtractor ---
    const trailerMediaKey = ref(0)
    const onTrailerAudioSaved = () => { trailerMediaKey.value += 1 }

    // --- Диалоги: перезагрузка списка после сохранения из DialogueAudioExtractor ---
    const dialogueMediaKey = ref(0)
    const onDialogueAudioSaved = () => { dialogueMediaKey.value += 1 }

    const isSerialMovie = computed(
      () => movieDetail.value.is_serial
        || ['TV_SERIES', 'MINI_SERIES', 'TV_SHOW'].includes(movieDetail.value.type),
    )

    const episodeFields = [
      { key: 'episode_number', label: '№' },
      { key: 'name_ru', label: 'Название' },
      { key: 'name_en', label: 'Оригинальное название' },
      { key: 'release_date', label: 'Дата выхода' },
      { key: 'synopsis', label: 'Синопсис' },
    ]

    // --- Каналы (только сериалы) ---
    const allChannels = ref([])
    const movieChannels = ref([])
    const isLoadingChannelsFromTmdb = ref(false)
    const isEditingChannels = ref(false)

    const fetchChannelsData = () => {
      const id = router.currentRoute.params.id
      store.dispatch('movies/fetchChannels').then(response => { allChannels.value = response.data.data })
      store.dispatch('movies/fetchMovieChannels', { id }).then(response => { movieChannels.value = response.data.data })
    }

    const saveChannels = () => {
      store.dispatch('movies/updateMovieChannels', {
        id: router.currentRoute.params.id,
        channels: movieChannels.value.map(channel => channel.id),
      })
        .catch(error => {
          toast({
            component: ToastificationContent,
            props: {
              title: error.response?.data?.message || 'Не удалось сохранить каналы',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    const loadChannelsFromTmdb = () => {
      isLoadingChannelsFromTmdb.value = true
      store.dispatch('movies/loadMovieChannelsFromTmdb', { id: router.currentRoute.params.id })
        .then(response => {
          movieChannels.value = response.data.data
          fetchChannelsData()
          toast({
            component: ToastificationContent,
            props: {
              title: 'Каналы загружены из TMDb',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          toast({
            component: ToastificationContent,
            props: {
              title: error.response?.data?.message || 'Ошибка при загрузке каналов из TMDb',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => { isLoadingChannelsFromTmdb.value = false })
    }

    const fetchSeasons = (force = false) => {
      if (!force && seasonsLoaded.value) return
      isLoadingSeasons.value = true
      store.dispatch('movies/fetchMovieSeasons', { id: router.currentRoute.params.id })
        .then(response => {
          seasons.value = response.data.data
          seasonsLoaded.value = true
          isLoadingSeasons.value = false
        })
        .catch(() => { isLoadingSeasons.value = false })
    }

    const fetchVideos = (force = false) => {
      if (!force && videosLoaded.value) return
      isLoadingVideos.value = true
      store.dispatch('movies/fetchMovieVideos', { id: router.currentRoute.params.id })
        .then(response => {
          videos.value = response.data.data
          videosLoaded.value = true
          isLoadingVideos.value = false
        })
        .catch(() => { isLoadingVideos.value = false })
    }

    const fetchAwards = (force = false) => {
      if (!force && awardsLoaded.value) return
      isLoadingAwards.value = true
      store.dispatch('movies/fetchMovieAwards', { id: router.currentRoute.params.id })
        .then(response => {
          awards.value = response.data.data
          awardsLoaded.value = true
          isLoadingAwards.value = false
        })
        .catch(() => { isLoadingAwards.value = false })
    }

    // Награды группируются по «награда + год»: внутри — номинации
    const awardsGrouped = computed(() => {
      const groups = []
      awards.value.forEach(award => {
        const key = `${award.name}|${award.year}`
        let group = groups.find(candidate => candidate.key === key)
        if (!group) {
          group = { key, name: award.name, year: award.year, items: [] }
          groups.push(group)
        }
        group.items.push(award)
      })
      return groups
    })

    const loadKpExtras = async () => {
      isLoadingKpExtras.value = true
      try {
        const response = await store.dispatch('movies/loadMovieKpExtras', { id: router.currentRoute.params.id })
        movieDetail.value = { ...movieDetail.value, ...response.data.data }
        if (seasonsLoaded.value) fetchSeasons(true)
        if (videosLoaded.value) fetchVideos(true)
        if (awardsLoaded.value) fetchAwards(true)
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: { title: 'Ошибка при дозагрузке из КП', icon: 'AlertTriangleIcon', variant: 'danger' },
        })
      } finally {
        isLoadingKpExtras.value = false
      }
    }

    // --- Франшизы ---
    const franchises = ref([])
    const isFranchiseModalVisible = ref(false)
    const franchiseOptions = ref([])
    const selectedFranchiseOption = ref(null)
    const franchisePartNumber = ref(null)

    const currentMovieId = computed(() => Number(router.currentRoute.params.id))

    // Окно вокруг текущего фильма: сам фильм и по 2 соседа с каждой стороны
    const franchiseWindow = franchise => {
      const movies = franchise.movies || []
      const currentIndex = movies.findIndex(item => item.id === currentMovieId.value)
      if (currentIndex === -1) return movies.slice(0, 5)
      return movies.slice(Math.max(0, currentIndex - 2), currentIndex + 3)
    }

    const fetchFranchises = () => {
      store.dispatch('movies/fetchMovieFranchises', {id: router.currentRoute.params.id})
          .then(response => {
            franchises.value = response.data.data
          })
          .catch(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Ошибка при загрузке франшиз',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
    }

    const onFranchiseSearch = (query, loading) => {
      loading(true)
      store.dispatch('movies/searchFranchises', {query})
          .then(response => {
            franchiseOptions.value = response.data.data
          })
          .finally(() => loading(false))
    }

    const openFranchiseModal = () => {
      selectedFranchiseOption.value = null
      franchisePartNumber.value = null
      isFranchiseModalVisible.value = true
      store.dispatch('movies/searchFranchises', {query: ''})
          .then(response => {
            franchiseOptions.value = response.data.data
          })
          .catch(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Ошибка при поиске франшиз',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
    }

    const submitFranchiseAttach = async () => {
      // Защита от уже созданных строковых tag'ов (старые версии vue-select без create-option)
      const option = typeof selectedFranchiseOption.value === 'string'
          ? {title: selectedFranchiseOption.value}
          : selectedFranchiseOption.value
      if (!option) return
      const partNumber = franchisePartNumber.value || null
      try {
        if (option.id) {
          await store.dispatch('movies/attachFranchiseMovie', {
            franchiseId: option.id,
            movie_id: currentMovieId.value,
            part_number: partNumber,
          })
        } else {
          // taggable-вариант: франшизы ещё нет, создаём сразу с привязкой фильма
          await store.dispatch('movies/createFranchise', {
            title: option.title,
            movie_id: currentMovieId.value,
            part_number: partNumber,
          })
        }
        isFranchiseModalVisible.value = false
        fetchFranchises()
        toast({
          component: ToastificationContent,
          props: {
            title: 'Фильм привязан к франшизе',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Ошибка при привязке к франшизе',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    }

    const fetchMovieData = () => {
      let id = router.currentRoute.params.id
      store.dispatch('movies/fetchMovieDetails', {id}).then(res => {
        movieDetail.value = res.data.data
        posterViewIndex.value = 0
        selectedClusterIds.value = (res.data.data.clusters || []).map(c => c.id)
        if (isSerialMovie.value) fetchChannelsData()
        if (movieDetail.value.posters_count > 0) fetchMoviePosters()
      })
    }

    // Сложность фильма/сериала: ручная оценка 1–10, как у артистов
    const updateDifficultyRating = async (rating) => {
      try {
        await store.dispatch('movies/updateMovie', {
          id: movieDetail.value.id,
          data: {difficulty_rating: rating},
        })
        movieDetail.value.difficulty_rating = rating
        toast({
          component: ToastificationContent,
          props: {
            title: 'Сложность обновлена',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Ошибка обновления сложности',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    }

    const recalcDifficultyLoading = ref(false)

    const recalculateDifficulty = async () => {
      recalcDifficultyLoading.value = true
      try {
        const response = await store.dispatch('movies/recalculateMovieDifficulty', {id: router.currentRoute.params.id})
        const movie = response.data.movie.data || response.data.movie
        movieDetail.value.calculated_difficulty = movie.calculated_difficulty
        toast({
          component: ToastificationContent,
          props: {
            title: 'Расчётная сложность пересчитана',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Ошибка пересчёта расчётной сложности',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        recalcDifficultyLoading.value = false
      }
    }

    // Кластеры фильма: мультиселект в шапке, правка зеркалируется в мультиселект «Кластер» страницы Notion
    const clusterOptions = ref([])
    const selectedClusterIds = ref([])
    const isSavingClusters = ref(false)

    store.dispatch('movies/fetchMovieClusters')
      .then(res => {
        clusterOptions.value = res.data.data || []
      })
      .catch(() => {})

    const saveClusters = async () => {
      const id = router.currentRoute.params.id
      isSavingClusters.value = true
      try {
        const response = await store.dispatch('movies/updateMovieClusters', {id, clusters: selectedClusterIds.value})
        movieDetail.value = {
          ...movieDetail.value,
          clusters: response.data.clusters || [],
        }
        toast({
          component: ToastificationContent,
          props: {
            title: response.data.message || 'Кластеры сохранены',
            icon: response.data.notion_synced === false ? 'AlertTriangleIcon' : 'CheckIcon',
            variant: response.data.notion_synced === false ? 'warning' : 'success',
          },
        })
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Ошибка сохранения кластеров',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        // Откат выбора к последнему сохранённому состоянию
        selectedClusterIds.value = ((movieDetail.value && movieDetail.value.clusters) || []).map(c => c.id)
      } finally {
        isSavingClusters.value = false
      }
    }

    // Колонки таблицы списков фильма на вкладке «Списки»
    const movieListsColumns = [
      { key: 'title', label: 'Название', sortable: true, thStyle: 'min-width: 260px' },
      { key: 'items_count', label: 'Элементов', sortable: true, thStyle: 'width: 120px' },
      { key: 'auto', label: 'Авто', sortable: true, thStyle: 'width: 90px' },
      { key: 'autotopics', label: 'Автотопики', sortable: false, thStyle: 'min-width: 220px' },
    ]

    // Ручные признаки содержимого постера; при ошибке откатываем переключатель
    const updatePosterFlag = (field, value) => {
      store.dispatch('movies/updateMovie', {
        id: movieDetail.value.id,
        data: {[field]: value},
      }).catch(() => {
        movieDetail.value[field] = !value
        toast({
          component: ToastificationContent,
          props: {
            title: 'Ошибка при сохранении признака постера',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
    }

    watch(() => router.currentRoute.params.id, (newId, oldId) => {
      if (newId !== oldId) {
        sequels.value = []
        sequelsLoaded.value = false
        movieFrames.value = []
        framesPreview.value = []
        previewSource.value = null
        selectedPreviewIds.value = []
        lastClickedPreviewId.value = null
        seasons.value = []
        seasonsLoaded.value = false
        videos.value = []
        videosLoaded.value = false
        awards.value = []
        awardsLoaded.value = false
        moviePosters.value = []
        posterViewIndex.value = 0
        isPostersModalVisible.value = false
        isPosterZoomVisible.value = false
        fetchMovieData()
        fetchFranchises()
      }
    })

    const refreshData = async () => {
      blockData()
      try {
        await fetchMovieData()
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error refreshing movie data',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        unblockData()
      }
    }

    const blockData = () => {
      isLoadingMovie.value = true
    }

    const unblockData = () => {
      isLoadingMovie.value = false
    }

    fetchMovieData()
    fetchFranchises()

    const addMovie = async (movie) => {
      movie.loading = true
      blockData()
      try {
        await store.dispatch(`movies/createMovie`, {kp_id: movie.filmId, title_ru: movie.nameRu})
        fetchSequels(true)
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error adding movie',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        unblockData()
      }
    }

    const importMovie = async () => {
      blockData()
      try {
        const response = await store.dispatch('movies/loadMovieFromKP', {
          id: router.currentRoute.params.id
        })
        movieDetail.value = response.data.data
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error importing movie (KP Unoff)',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        unblockData()
      }
    }

    const importMovieKpDev = async () => {
      blockData()
      try {
        const response = await store.dispatch('movies/loadMovieFromKPDev', {
          id: router.currentRoute.params.id
        })
        movieDetail.value = response.data.data
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error importing movie (KP.dev)',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        unblockData()
      }
    }

    const syncNotion = async () => {
      blockData()
      try {
        const response = await store.dispatch('movies/syncMovieNotion', {
          id: router.currentRoute.params.id
        })
        toast({
          component: ToastificationContent,
          props: {
            title: response.data.message || 'Синхронизировано с Notion',
            icon: response.data.success ? 'CheckIcon' : 'AlertTriangleIcon',
            variant: response.data.success ? 'success' : 'danger',
          },
        })
        // Синк меняет название/notion_id — перезагружаем деталку
        if (response.data.success) fetchMovieData()
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: error.response?.data?.message || 'Ошибка синка с Notion',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        unblockData()
      }
    }

    const importStaff = async () => {
      blockData()
      try {
        const response = await store.dispatch('movies/loadStaffFromKP', {
          id: router.currentRoute.params.id
        })
        movieDetail.value = response.data.data
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error importing staff',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        unblockData()
      }
    }

    return {
      importMovie,
      importMovieKpDev,
      syncNotion,
      updateDifficultyRating,
      recalcDifficultyLoading,
      recalculateDifficulty,
      clusterOptions,
      selectedClusterIds,
      isSavingClusters,
      saveClusters,
      movieListsColumns,
      importStaff,
      addMovie,
      formatDate,
      formatDateTime,
      ratingFmt,
      formatNumber,
      movieDetail,
      sequels,
      sequelsLoaded,
      fetchSequels,
      isLoadingMovie,
      isLoadingStaff,
      disabledMovieId,
      refreshData,
      blockData,
      unblockData,
      updatePosterFlag,
      showAllActors,
      visibleActors,
      movieFrames,
      isLoadingFrames,
      isFrameModalVisible,
      selectedFrame,
      fetchFrames,
      openFrame,
      toggleFrame,
      framesPreview,
      previewSource,
      previewSourceTitle,
      isLoadingPreview,
      isDownloadingFrames,
      selectedPreviewIds,
      fetchPreviewFrames,
      isPreviewFrameSelected,
      togglePreviewFrameSelection,
      selectAllPreviewFrames,
      clearPreviewSelection,
      closePreview,
      downloadSelectedFrames,
      deleteFrame,
      isRatingHistoryVisible,
      ratingHistoryMode,
      openRatingHistory,
      moviePosters,
      posterViewIndex,
      isPostersModalVisible,
      isPosterZoomVisible,
      posterViewList,
      currentPosterView,
      currentPosterFullView,
      goPrevPosterView,
      goNextPosterView,
      onMoviePostersUpdated,
      franchises,
      franchiseWindow,
      currentMovieId,
      isFranchiseModalVisible,
      franchiseOptions,
      selectedFranchiseOption,
      franchisePartNumber,
      openFranchiseModal,
      onFranchiseSearch,
      submitFranchiseAttach,
      seasons,
      seasonsLoaded,
      isLoadingSeasons,
      fetchSeasons,
      videos,
      videosLoaded,
      isLoadingVideos,
      fetchVideos,
      awards,
      awardsLoaded,
      isLoadingAwards,
      fetchAwards,
      awardsGrouped,
      isSerialMovie,
      episodeFields,
      isLoadingKpExtras,
      loadKpExtras,
      soundtracksCount,
      soundtracksLoaded,
      onSoundtracksUpdated,
      trailerMediaKey,
      onTrailerAudioSaved,
      dialogueMediaKey,
      onDialogueAudioSaved,
      allChannels,
      movieChannels,
      isLoadingChannelsFromTmdb,
      isEditingChannels,
      saveChannels,
      loadChannelsFromTmdb,
      externalSources,
      searchingExternalSource,
      showAddExternalIdModal,
      externalIdInput,
      isAddingExternalId,
      externalId,
      externalTitle,
      externalUrl,
      searchExternalId,
      addExternalId,
      deleteExternalId,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/pages/page-blog.scss';

// Контейнер фиксированной высоты: размеры не скачут между постерами разных пропорций,
// стрелки лежат поверх постера и не выдавливаются за узкую колонку
.poster-view-wrapper {
  position: relative;
  height: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.poster-view-img {
  max-height: 100%;
  max-width: 100%;
  width: auto;
  object-fit: contain;
}

.poster-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  opacity: 0.75;
  background-color: rgba(34, 41, 47, 0.35) !important;
  color: #fff !important;

  &:hover:not(:disabled) {
    opacity: 1;
    background-color: rgba(34, 41, 47, 0.6) !important;
  }
}

.poster-nav-btn-left {
  left: 0.25rem;
}

.poster-nav-btn-right {
  right: 0.25rem;
}

// Лупа в правом верхнем углу постера, вне зоны стрелок навигации
.poster-zoom-btn {
  top: 0.25rem;
  right: 0.25rem;
  transform: none;
}

// Постер в модалке: ограничиваем высотой окна, чтобы не скроллить
.poster-zoom-img {
  max-height: 82vh;
  width: auto;
}

// Каунт постеров на кнопке «Постеры»: аутлайн-бейдж зелёным, чтобы выделялся
.posters-count-badge {
  background-color: transparent !important;
  border: 1px solid #28c76f;
  color: #28c76f !important;
}

.channel-badge {
  display: inline-flex;
  align-items: center;
  font-size: 0.95rem;
}

.channel-badge-logo {
  height: 14px;
  max-width: 56px;
  object-fit: contain;
}

.movie-info-table {
  th {
    white-space: nowrap;
    width: 1%;
    padding-right: 1rem;
  }
}

// Панели шапки (название и оценки) — фон и рамка, чтобы не терялись на фоне обложки
.movie-header-panel {
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid #ebe9f1;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;

  .dark-layout & {
    background: rgba(40, 48, 70, 0.85);
    border-color: #3b4253;
  }
}

.movie-title-panel {
  margin-right: 1rem;

  .movie-title-ru {
    font-size: 2.5rem;
  }

  .movie-title-original {
    font-size: 1.4rem;
  }
}

// Обложка фильма — фоновый слой карточки: вверху 40% непрозрачности, градиентно сходит к 0 за 400px
.movie-detail-card {
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 400px;
    background-image: var(--movie-cover);
    background-size: cover;
    background-position: center top;
    opacity: 0.4;
    -webkit-mask-image: linear-gradient(to bottom, #000 0, transparent 400px);
    mask-image: linear-gradient(to bottom, #000 0, transparent 400px);
    pointer-events: none;
  }

  > .card-body {
    position: relative;
    z-index: 1;
  }
}

.frames-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
}

.frame-item-wrapper {
  position: relative;
  aspect-ratio: 1 / 1;
}

.frame-item {
  width: 100%;
  height: 100%;
  border-radius: 0.5rem;
  overflow: hidden;
  cursor: pointer;
  user-select: none;
  border: 1px solid #ebe9f1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f8f8;

  .frame-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    &.grayscale {
      filter: grayscale(1);
      opacity: 0.5;
    }
  }

  &.border-danger {
    border-width: 2px !important;
  }
}

.frame-toggle-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 5px !important;
  background-color: rgba(255, 255, 255, 0.8) !important;
  &:hover {
    background-color: rgba(255, 255, 255, 1) !important;
  }
}

.frame-delete-btn {
  top: 40px;
}

.frame-item-selected {
  border: 2px solid #7367f0 !important;
}

.frame-selected-check {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #7367f0;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.frame-corner-badge {
  position: absolute;
  top: 5px;
  left: 5px;
  pointer-events: none;
}

.frame-s3-badge {
  position: absolute;
  bottom: 5px;
  left: 5px;
  pointer-events: none;
}

.frame-modal {
  .modal-body {
    padding: 0;
  }
}

.frame-modal-toggle-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
